import { useTranslation } from 'next-i18next';
import { CheckIcon } from '@/icons';
import { useLtiSelectAction } from '@/shared/lti/hooks/useLtiSelectAction';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
interface LtiSelectQuizButtonProps {
  quizSetId: string;
  entryMapHashId: string;
  quizTitle: string;
  className?: string;
  fullWidth?: boolean;
}
export function LtiSelectQuizButton({
  quizSetId,
  entryMapHashId,
  quizTitle,
  className,
  fullWidth
}: LtiSelectQuizButtonProps) {
  const {
    t
  } = useTranslation(['common']);
  const {
    selectQuiz,
    status
  } = useLtiSelectAction();
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    void selectQuiz({
      quizSetId,
      entryMapHashId,
      quizTitle
    });
  };
  const isDisabled = status === 'loading' || status === 'success';
  const label = {
    idle: t('lti.action.selectQuiz'),
    loading: t('lti.action.selecting'),
    success: t('lti.action.selected'),
    error: t('lti.action.selectQuiz')
  }[status];
  return <Button size="md" intent="strong" disabled={isDisabled} onClick={handleClick} className={cn(fullWidth && 'w-full', className)} data-sentry-element="Button" data-sentry-component="LtiSelectQuizButton" data-sentry-source-file="LtiSelectQuizButton.tsx">
      <div className="flex items-center gap-2xs">
        {status === 'loading' ? <div className="size-4 animate-spin rounded-full border-2 border-white border-t-transparent" /> : <CheckIcon size="xs" className="shrink-0" />}
        {label}
      </div>
    </Button>;
}